import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const tradeJobsCities = [
  {
    name: 'Cardiff',
    slug: 'cardiff',
    region: 'South Wales',
    description: 'Find Local Trade Jobs in Cardiff — Get Paid Fast',
    image: 'https://public.readdy.ai/ai/img_res/4360505c92d41fd2b7e052aecf6dee3a.jpg'
  },
  {
    name: 'London',
    slug: 'london',
    region: 'Greater London',
    description: 'Flexible Trade Jobs Across London — No Bidding Required',
    image: 'https://readdy.ai/api/search-image?query=skilled%20tradesperson%20working%20on%20residential%20property%20in%20London%20cityscape%20background%20professional%20tools%20modern%20urban%20setting&width=800&height=600&seq=london-trade-1&orientation=landscape'
  },
  {
    name: 'Birmingham',
    slug: 'birmingham',
    region: 'West Midlands',
    description: 'Local Trade Work in Birmingham — When You Want It',
    image: 'https://readdy.ai/api/search-image?query=tradesperson%20completing%20home%20maintenance%20job%20in%20Birmingham%20modern%20residential%20area%20professional%20equipment%20bright%20workspace&width=800&height=600&seq=birmingham-trade-1&orientation=landscape'
  },
  {
    name: 'Manchester',
    slug: 'manchester',
    region: 'Greater Manchester',
    description: 'Trade Jobs in Manchester — Simple, Fair & Flexible',
    image: 'https://readdy.ai/api/search-image?query=professional%20tradesperson%20working%20on%20plumbing%20electrical%20job%20in%20Manchester%20residential%20property%20modern%20tools%20clean%20workspace&width=800&height=600&seq=manchester-trade-1&orientation=landscape'
  },
  {
    name: 'Leeds',
    slug: 'leeds',
    region: 'West Yorkshire',
    description: 'Find Trade Jobs Near You in Leeds',
    image: 'https://readdy.ai/api/search-image?query=skilled%20tradesperson%20performing%20handyman%20work%20in%20Leeds%20home%20modern%20professional%20tools%20bright%20clean%20environment&width=800&height=600&seq=leeds-trade-1&orientation=landscape'
  },
  {
    name: 'Liverpool',
    slug: 'liverpool',
    region: 'Merseyside',
    description: 'Local Trade Jobs in Liverpool — No Lead Fees',
    image: 'https://readdy.ai/api/search-image?query=tradesperson%20working%20on%20home%20repair%20job%20in%20Liverpool%20residential%20area%20professional%20equipment%20modern%20workspace&width=800&height=600&seq=liverpool-trade-1&orientation=landscape'
  },
  {
    name: 'Bristol',
    slug: 'bristol',
    region: 'South West England',
    description: 'Bristol Trade Jobs — Work on Your Schedule',
    image: 'https://readdy.ai/api/search-image?query=professional%20tradesperson%20completing%20maintenance%20work%20in%20Bristol%20modern%20home%20bright%20workspace%20quality%20tools&width=800&height=600&seq=bristol-trade-1&orientation=landscape'
  },
  {
    name: 'Sheffield',
    slug: 'sheffield',
    region: 'South Yorkshire',
    description: 'Find Local Trade Work in Sheffield',
    image: 'https://readdy.ai/api/search-image?query=skilled%20tradesperson%20working%20on%20residential%20job%20in%20Sheffield%20professional%20tools%20modern%20clean%20workspace%20bright%20environment&width=800&height=600&seq=sheffield-trade-1&orientation=landscape'
  },
  {
    name: 'Nottingham',
    slug: 'nottingham',
    region: 'East Midlands',
    description: 'Trade Jobs in Nottingham — Flexible & Local',
    image: 'https://readdy.ai/api/search-image?query=tradesperson%20performing%20home%20services%20in%20Nottingham%20residential%20property%20modern%20professional%20equipment%20clean%20workspace&width=800&height=600&seq=nottingham-trade-1&orientation=landscape'
  },
  {
    name: 'Leicester',
    slug: 'leicester',
    region: 'East Midlands',
    description: 'Local Trade Jobs in Leicester — Get Started Fast',
    image: 'https://readdy.ai/api/search-image?query=professional%20tradesperson%20working%20on%20maintenance%20job%20in%20Leicester%20modern%20home%20bright%20workspace%20quality%20tools&width=800&height=600&seq=leicester-trade-1&orientation=landscape'
  }
];

export default function TradeJobs() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(null);

  useEffect(() => {
    // Set document title and meta tags
    document.title = 'Trade Jobs UK | Find Local Handyman, Plumber & Electrician Jobs - Taskbudy';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Find local trade jobs across the UK with Taskbudy. Browse handyman, plumbing, electrical, cleaning, waste removal & transport jobs in London, Birmingham, Manchester, Leeds, Liverpool, Glasgow, Edinburgh, Cardiff, Newport, Swansea, Bristol & Newcastle.');
    }
  }, []);

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      setMessage({ type: 'error', text: 'Please enter a valid email address' });
      return;
    }

    setIsSubmitting(true);
    setMessage(null);

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d5sj2m399ei0h7kmaj6g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setMessage({ type: 'success', text: 'Thank you for subscribing!' });
        setEmail('');
      } else {
        setMessage({ type: 'error', text: 'Something went wrong. Please try again.' });
      }
    } catch (error) {
      setMessage({ type: 'error', text: 'Failed to subscribe. Please try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="min-h-screen bg-white">
        {/* Navigation */}
        <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-100 z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <Link to="/" className="flex items-center">
                <img 
                  src="https://static.readdy.ai/image/a3382d87126fc476a032aa8f5ebcbb38/dc77c2be5a78759d16f1acf02198b697.png" 
                  alt="TaskBudy" 
                  className="h-8 md:h-10 lg:h-12"
                />
              </Link>
              <div className="flex items-center space-x-6">
                <Link to="/provider-signup" className="text-sm font-medium text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap">
                  Apply Now
                </Link>
                <Link to="/signin" className="text-sm font-medium text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap">
                  Sign In
                </Link>
              </div>
            </div>
          </div>
        </nav>

        {/* Breadcrumb */}
        <div className="pt-20 pb-4 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <nav className="flex items-center space-x-2 text-sm">
              <Link to="/" className="text-gray-500 hover:text-teal-600 transition-colors">Home</Link>
              <i className="ri-arrow-right-s-line text-gray-400"></i>
              <span className="text-gray-900 font-medium">Trade Jobs</span>
            </nav>
          </div>
        </div>

        {/* Hero Section */}
        <section className="bg-gradient-to-br from-teal-50 via-white to-orange-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Find <strong>Trade Jobs</strong> in Your City
            </h1>
            <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
              Taskbudy connects skilled tradespeople with local, paid work across the UK. No bidding, no lead fees — just real jobs sent directly to you.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link 
                to="/provider-signup"
                className="px-8 py-4 bg-teal-500 text-white font-semibold rounded-lg hover:bg-teal-600 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
              >
                Apply as a Tradesperson
              </Link>
              <a 
                href="#cities"
                className="px-8 py-4 bg-white text-teal-600 font-semibold rounded-lg hover:bg-gray-50 transition-colors border-2 border-teal-500 whitespace-nowrap cursor-pointer"
              >
                Browse Cities
              </a>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">
              Why Tradespeople Choose Taskbudy
            </h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center p-6">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-money-pound-circle-line text-teal-600 text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">No Lead Fees</h3>
                <p className="text-gray-600">
                  Unlike other platforms, we don't charge you for leads or make you bid for work. Jobs are sent directly to you.
                </p>
              </div>
              <div className="text-center p-6">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-calendar-check-line text-orange-600 text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Work Your Way</h3>
                <p className="text-gray-600">
                  Choose ASAP or scheduled jobs. Accept what suits you and work on your own terms with full flexibility.
                </p>
              </div>
              <div className="text-center p-6">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-teal-600 text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Fair & Transparent</h3>
                <p className="text-gray-600">
                  Clear pricing, fast payments, and full support. We're here to help you succeed and grow your business.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Cities Grid */}
        <section id="cities" className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-gray-900 text-center mb-4">
              Find <strong>Trade Jobs</strong> in Your City
            </h2>
            <p className="text-lg text-gray-600 text-center mb-12 max-w-2xl mx-auto">
              Select your city to see available trade jobs and start earning today
            </p>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {tradeJobsCities.map((city) => (
                <Link
                  key={city.slug}
                  to={`/trade-jobs-${city.slug}`}
                  className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer"
                >
                  <div className="relative h-48 w-full overflow-hidden">
                    <img
                      src={city.image}
                      alt={`Trade jobs in ${city.name}`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                    <div className="absolute bottom-4 left-4 right-4">
                      <h3 className="text-2xl font-bold text-white mb-1">
                        {city.name}
                      </h3>
                      <p className="text-sm text-white/90">{city.region}</p>
                    </div>
                  </div>
                  <div className="p-6">
                    <p className="text-gray-600 mb-4">{city.description}</p>
                    <div className="flex items-center text-teal-600 font-semibold group-hover:text-teal-700">
                      <span className="whitespace-nowrap">View {city.name} Jobs</span>
                      <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Trades Section */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">
              Available Trade Categories
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[
                { icon: 'ri-tools-line', name: 'Handyman Services', desc: 'General repairs, assembly, maintenance' },
                { icon: 'ri-drop-line', name: 'Plumbing', desc: 'Leaks, installations, emergency repairs' },
                { icon: 'ri-flashlight-line', name: 'Electrical Work', desc: 'Wiring, installations, fault finding' },
                { icon: 'ri-brush-line', name: 'Cleaning Services', desc: 'Deep cleaning, end of tenancy, regular' },
                { icon: 'ri-delete-bin-line', name: 'Waste Removal', desc: 'Rubbish clearance, garden waste, junk' },
                { icon: 'ri-truck-line', name: 'Transportation', desc: 'Deliveries, removals, courier services' }
              ].map((trade, index) => (
                <div key={index} className="p-6 bg-gray-50 rounded-lg hover:bg-teal-50 transition-colors">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                    <i className={`${trade.icon} text-teal-600 text-2xl`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{trade.name}</h3>
                  <p className="text-gray-600 text-sm">{trade.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-gradient-to-br from-teal-500 to-teal-600">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Ready to Start Receiving Trade Jobs?
            </h2>
            <p className="text-xl text-white/90 mb-8">
              Join thousands of tradespeople already working with Taskbudy across the UK
            </p>
            <Link
              to="/provider-signup"
              className="inline-block px-8 py-4 bg-white text-teal-600 font-semibold rounded-lg hover:bg-gray-50 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
            >
              Apply Now — It's Free
            </Link>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-gray-900 text-white py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Newsletter Section */}
            <div className="mb-12 pb-12 border-b border-gray-800">
              <div className="max-w-2xl mx-auto text-center">
                <h3 className="text-2xl font-bold mb-3">Stay Updated</h3>
                <p className="text-gray-400 mb-6">Subscribe to our newsletter for the latest updates and offers</p>
                <form 
                  id="newsletter-form-trade"
                  data-readdy-form
                  onSubmit={handleNewsletterSubmit}
                  className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
                >
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    className="flex-1 px-4 py-3 rounded-lg bg-white/10 border border-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                    required
                    disabled={isSubmitting}
                  />
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="px-6 py-3 bg-teal-500 text-white font-semibold rounded-lg hover:bg-teal-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                  >
                    {isSubmitting ? 'Subscribing...' : 'Subscribe'}
                  </button>
                </form>
                {message && (
                  <p className={`mt-3 text-sm ${message.type === 'success' ? 'text-green-400' : 'text-red-400'}`}>
                    {message.text}
                  </p>
                )}
              </div>
            </div>

            <div className="grid md:grid-cols-4 gap-8 mb-8">
              <div>
                <div className="flex items-center space-x-2 mb-4">
                  <div className="w-8 h-8 bg-teal-500 rounded-lg flex items-center justify-center">
                    <i className="ri-tools-fill text-white text-lg"></i>
                  </div>
                  <span className="text-xl font-bold">Taskbudy</span>
                </div>
                <p className="text-gray-400 text-sm">
                  Connecting tradespeople with local work across the UK
                </p>
              </div>
              <div>
                <h4 className="font-semibold mb-4">For Tradespeople</h4>
                <ul className="space-y-2 text-sm">
                  <li><Link to="/provider-signup" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Apply Now</Link></li>
                  <li><Link to="/pricing" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Pricing</Link></li>
                  <li><Link to="/provider-login" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Provider Login</Link></li>
                </ul>
              </div>
              <div>
                <h4 className="font-semibold mb-4">For Customers</h4>
                <ul className="space-y-2 text-sm">
                  <li><Link to="/" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Book a Service</Link></li>
                  <li><Link to="/services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">All Services</Link></li>
                  <li><Link to="/locations" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Locations</Link></li>
                </ul>
              </div>
              <div>
                <h4 className="font-semibold mb-4">Company</h4>
                <ul className="space-y-2 text-sm">
                  <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors cursor-pointer">About Us</Link></li>
                  <li><Link to="/contact" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Contact</Link></li>
                </ul>
              </div>
            </div>
            <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
              <p>© 2025 Taskbudy. All rights reserved.</p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}
